export const INTERCOM_APP_ID = "sl5gz67c";
export const GOOGLE_OPTIMIZE_ID = "OPT-KB2NNT5";
